module.exports = __webpack_public_path__ + "static/img/1-5.a373fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-5.png
// module id = m81H
// module chunks = 1